// @flow

export function fbAutoLoginNotAuthorized() {
  return {
    type: 'FB_AUTOLOGIN_NOT_AUTHORIZED',
    payload: {},
  };
}

export function fbAutoLoginAuthorizationExpired() {
  return {
    type: 'FB_AUTOLOGIN_AUTH_EXPIRED',
    payload: {},
  };
}

export function fbAutoLoginConnected() {
  return {
    type: 'FB_AUTOLOGIN_CONNECTED',
    payload: {},
  };
}

export function fbAutoLoginUnknown() {
  return {
    type: 'FB_AUTOLOGIN_UNKNOWN',
    payload: {},
  };
}
